import { Pagination } from "api/models/response/pagination";
import { flow, types } from "mobx-state-tree";
import { withRootStore } from "mobx-stores/_extension/with-root-store";

import { workOrderBusiness } from "api/bussiness/work-order/work-order-bussiness";
import { GetWorkOrders } from "api/models/request/work-order/work-order";
import { withReset } from "mobx-stores/_extension/with-reset";
import {
  IWorkOrderProperties,
  WorkOrder,
} from "mobx-stores/_models/work-order/work-order";
import { WorkOrderItem } from "mobx-stores/_models/work-order/work-order-item";
import { withSetPropAction } from "../_extension/with-set-props";
import { DateRangeFilterStore } from "./common/date-range-filter-store";
import { PaginationStore } from "./common/pagination-store";

export const UpdateDepartmentProcess = types
  .model({
    open: false,
    woItemId: types.maybeNull(types.string),
    type: types.maybeNull(types.number),
    amount: types.maybeNull(types.number),
    date: types.maybeNull(types.string),
  })
  .actions(withSetPropAction)
  .actions(withReset);

export const WorkOrderQueryParams = types
  .model({
    poDateRangeFilter: types.optional(DateRangeFilterStore, {}),
    deliveryDateRangeFilter: types.optional(DateRangeFilterStore, {}),
    name: "",
    dealingName: "",
    wONumber: "",
    dateRangeFilter: types.optional(DateRangeFilterStore, {}),
  })
  .actions(withSetPropAction);
export const WorkOrderManagement = types
  .model({
    workOrders: types.optional(types.array(WorkOrder), []),
    pagination: types.optional(PaginationStore, {}),
    workOrderDetail: types.maybeNull(WorkOrder),
    selectedWorkOrderItem: types.maybeNull(WorkOrderItem),
    openNew: false,
    openEdit: false,
    openDelete: false,
    openPackagePrint: false,
    updateDepartmentProcess: types.optional(UpdateDepartmentProcess, {}),
    queryParams: types.optional(WorkOrderQueryParams, {}),
  })
  .extend(withRootStore)
  .actions(withSetPropAction)
  .actions((self) => ({
    getWorkOrders: flow(function* getWorkOrders(request?: GetWorkOrders) {
      try {
        self._rootStore.setProp("inProgress", true);
        if (!request) {
          request = {
            filter: self.pagination.filter,
            maxResultCount: self.pagination.itemsPerPage,
            skipCount: self.pagination.skipCount,
            sorting: "",
            fromDate:
              self.queryParams.dateRangeFilter.fromAsDayJs?.isValid() &&
              self.queryParams.dateRangeFilter.from
                ? self.queryParams.dateRangeFilter.from
                : undefined,
            toDate:
              self.queryParams.dateRangeFilter.toAsDayJs?.isValid() &&
              self.queryParams.dateRangeFilter.to
                ? self.queryParams.dateRangeFilter.to
                : undefined,
            dealingName: self.queryParams.dealingName,
            name: self.queryParams.name,
            wONumber: self.queryParams.wONumber,
          };
        }
        const res = (yield workOrderBusiness.getLists(
          request,
        )) as Pagination<IWorkOrderProperties>;
        self.setProp(
          "workOrders",
          res.items?.map((x, i) => ({
            ...x,
            orderNumber:
              i + 1 + self.pagination.pageIndex * self.pagination.itemsPerPage,
          })),
        );
        self.pagination.setProp("totalItems", res.totalCount);
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
    getWorkOrderDetail: flow(function* getWorkOrderDetail(id: string) {
      try {
        self._rootStore.setProp("inProgress", true);
        const res = (yield workOrderBusiness.getById(
          id,
        )) as IWorkOrderProperties;
        self.setProp("workOrderDetail", res);
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
  }));
